<template><div>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" @openMenu="openMenu" />

    <dashboard-core-drawer
      ref="myAsdDrawer"
      :expand-on-hover.sync="expandOnHover"
      v-model="openMenu"
    />

    <dashboard-core-view />
        
  </v-app>
  <v-dialog max-width="256" max-height="256" persistent v-model="dialogLoading" id="dialog-loader" style="z-index: 1000 !important"
    content-class="elevation-0">
    <img :src="loader" />
  </v-dialog></div>
</template>

<script>
export default {
  name: "DashboardIndex",

  components: {
    DashboardCoreAppBar: () => import("./components/core/AppBar"),
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    DashboardCoreView: () => import("./components/core/View"),
  },

  data: () => ({
    drawer: false,
    expandOnHover: screen.width > 648,
    loader: window.systemData.THEME.loader,
  }),
  methods: {
    openMenu() {
      this.$refs.myAsdDrawer.openMenu();
    },
  },
  computed: {
    
    dialogLoading() {
      return this.$globalHandler.dialogLoader.visible;
    },

  },
};
</script>
